import { ApiError } from '../../../../../shared/shared.api';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';

export type ContactKind = 'email' | 'phone';

interface ContactCopy {
  /** Finishes "To …, enter the code" on the confirmation step. */
  purpose: string;
  fieldLabel: string;
  changed: string;
  taken: string;
  unchanged: string;
}

export const CONTACT_COPY: Record<ContactKind, ContactCopy> = {
  email: {
    purpose: 'change your email',
    fieldLabel: 'New email',
    changed: 'Email changed',
    taken: 'Another user already has this email.',
    unchanged: 'That is already your email.',
  },
  phone: {
    purpose: 'change your mobile number',
    fieldLabel: 'New mobile number',
    changed: 'Mobile number changed',
    taken: 'Another user already has this mobile number.',
    unchanged: 'That is already your mobile number.',
  },
};

/** What to say beside the field when sending the code or checking it fails: taken (409), unchanged (400), a wrong code (422, the server's reason). */
export function contactChangeError(kind: ContactKind, err: unknown): string {
  const copy = CONTACT_COPY[kind];
  if (err instanceof ApiError && err.status === 409) return copy.taken;
  if (err instanceof ApiError && err.status === 400) return apiErrorMessage(err) ?? copy.unchanged;
  if (err instanceof ApiError && err.status === 422) return apiErrorMessage(err) ?? 'Incorrect code. Check the newest one and try again.';
  return apiErrorMessage(err) ?? "Couldn't change it. Try again.";
}
